import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getAdvanD = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.ADVANCE_D_URL}` + `/getadvanD`, data);
};

export const billing_expense_getAllDById = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.ADVANCE_D_URL}/getAllDetailById/${id}`);
};

export const billing_expense_addAdvanceD = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.ADVANCE_D_URL}`, data);
};

export const billing_expense_deleteAdvanceD = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.ADVANCE_D_URL}` + `/${id}`);
};

export const billing_expense_updateAdvanceD = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.ADVANCE_D_URL}` + `/${id}`, data);
};

export const billing_expense_printInvAD = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.ADVANCE_D_URL}` + `/print_inv_ad/${id}`);
};